<div class="grid-x actions">
  <div
    *ngFor="let action of actions"
    class="cell shrink actions__item"
    [ngClass]="!TableActions.shouldShow(action, selectedItems) ? 'hide' : ''"
  >
    <button
      *ngIf="scope.hasAccesses(action.scope) && showAction(action)"
      (click)="actionTriggered.next(action.name)"
      [ngClass]="!TableActions.shouldShow(action, selectedItems) ? 'hide' : ''"
      [disabled]="!TableActions.isEnabled(action, selectedItems) || action.disabled"
      class="grid-y"
    >
      <rav-icon
        [name]="currentIcon(action)"
        class="cell align-self-middle actions__icon"
        [matTooltip]="getCustomTooltip(action) || action.tooltip"
      ></rav-icon>
      <span class="cell align-self-middle actions__name"> {{ actionName(action) }}</span>
    </button>
  </div>
</div>
